import { render, staticRenderFns } from "./main-sidebar.vue?vue&type=template&id=0340b4eb&scoped=true&"
import script from "./main-sidebar.vue?vue&type=script&lang=js&"
export * from "./main-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./main-sidebar.vue?vue&type=style&index=0&id=0340b4eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0340b4eb",
  null
  
)

export default component.exports